import type { FC } from 'react'
import { useTranslate } from '@hooks/useTranslation'
import { CwsP, CwsH3, CwsGrid, CwsGridRow, CwsGridCol, CwsSection } from '@components/cws'
import { useInitialData } from '@context/initialDataContext'

const ProductViewDeliveryInfo: FC = () => {
  const { translate } = useTranslate()
  const {
    initialData: { deliveryInfo },
  } = useInitialData()
  return (
    <CwsGridRow>
      <CwsGridCol>
        <CwsH3 className="leading-7.5">{translate('product.detail.description.delivery')}</CwsH3>
        <CwsP dangerouslySetInnerHTML={{ __html: deliveryInfo }}></CwsP>
      </CwsGridCol>
    </CwsGridRow>
  )
}

export default ProductViewDeliveryInfo
